import { Routes, Route } from "react-router-dom";
import routes from "../routes/routes";
import Layout from "../common/layout";
import NotFoundPage from "../pages/notFound";

function App() {
  return (
    <Routes>
      {
        routes.map(({ path, component: Component }, index) => (
          <Route
            key={index}
            path={path}
            element={
              <Layout >
                <Component />
              </Layout>
            }
          />
        ))
      }
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
